import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";
import { maxAnioCiclo, minAnioCiclo } from "screens/Ciclo/constants";

export const createCicloSchema = yup.object({
  nombre: yup.string().required(DEFAULT_MESSAGES.REQUIRED),
  descripcion: yup.string().optional(),
  anioInicial: yup
    .number()
    .typeError(DEFAULT_MESSAGES.REQUIRED)
    .required(DEFAULT_MESSAGES.REQUIRED)
    .min(minAnioCiclo, `El año inicial no puede ser menor a ${minAnioCiclo}`)
    .max(maxAnioCiclo, `El año inicial no puede ser mayor a ${maxAnioCiclo}`),
  anioFinal: yup
    .number()
    .typeError(DEFAULT_MESSAGES.REQUIRED)
    .required(DEFAULT_MESSAGES.REQUIRED)
    .min(minAnioCiclo, `El año final no puede ser menor a ${minAnioCiclo}`)
    .max(maxAnioCiclo, `El año final no puede ser mayor a ${maxAnioCiclo}`)
    .when("anioInicial", (anioInicial, schema) =>
      schema.test(
        "anioFinal-mayor",
        "El año final debe ser mayor al año inicial",
        (anioFinal) => {
          if (anioInicial === undefined || anioFinal === undefined) {
            return true; // Evita validar si uno de los valores es undefined
          }
          return Number(anioFinal) > Number(anioInicial);
        },
      ),
    ),
});
